import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  HostListener,
  AfterViewInit,
  AfterViewChecked,
  ElementRef, ViewChild
} from '@angular/core';
import { Observable } from 'rxjs/Observable';

import {
  Translate
} from '../../services';
import {ViewSelectors} from "../../logics/view";
import {Subject} from "rxjs";

@Component({
  selector: 'cs-navigator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="cs-navigator">
    
      <div class="cs-navigator__next-prev-arrows">
        <a 
          class="cs-btn cs-btn-cta"
          [ngClass]="{
            'disabled': inputs.current?.id === inputs.questions[0]?.id
          }"
          (click)="goToPrevQuestion()">
          <span class="ion-chevron-left"></span>
        </a>
        <a 
          class="cs-btn cs-btn-cta"
          [ngClass]="{
            'disabled': inputs.current?.id === inputs.questions.slice(-1)[0]?.id
          }"
          (click)="goToNextQuestion()">
          <span class="ion-chevron-right"></span>
        </a>
      </div >
      
      <div class="cs-navigator__slides"
           [ngClass]="{
            'cs-navigator__slides-arrows': showArr
            }">
        <!-- Arrow to scroll tabs on the left -->
        <a
          class="cs-btn cs-navigator__slides-arrow"
           [ngClass]="{
            'notShowing': !showArr
          }"
          (click)="nextBtns()">
          <span class="ion-chevron-left"></span>
        </a>
        
        <div class="cs-navigator__slides-container" 
             #slidesBox>
          <ul #slidesList
            class="cs-navigator__slides-list">
            <li
              class="cs-navigator__sldes-item"
              [ngClass]="{
              'cs-navigator__sldes-text': item.comprensionText,
              'cs-navigator__ma-text': item.multipleAnswer,
              'is-current': item.id === inputs.current?.id,
              'is-completed': isCompletedByQuestionId(item.id, item.otherQuestionIds)
            }"
              (click)="goToQuestion(item)"
              *ngFor="let item of inputs.questions">
              <a
                [ngStyle]="{
                'background-color': colorStatusByQuestionId(item.id, item.otherQuestionIds)
              }">
                <span [innerHTML]="item.label"></span>
              </a>
            </li>
          </ul>
        </div>
        
        <!-- Arrow to scroll tabs on the left -->
        <a
          class="cs-btn cs-navigator__slides-arrow" 
          [ngClass]="{
            'notShowing': !showArr
          }"          
          (click)="prevBtns()">
          <span class="ion-chevron-right"></span>
        </a>
      </div>
      
      <a
        class="cs-navigator__exit cs-btn cs-btn-l cs-btn-light" 
        (click)="terminate.emit(inputs.isCompleted)">
		{{ (translations$ | async)[(inputs.isCompleted) ? 'global#results' : 'global#end'] }}
        <span *ngIf="!inputs.isCompleted" class="ion-close-round"></span>
      </a>

    </div>
  `
})

export class CsNavigatorComponent implements AfterViewInit, AfterViewChecked {
  public showArr: boolean = false;
  public current_id: number;

  private isAudioExtPlaying: boolean = false;

  @ViewChild('slidesBox') slidesBox: ElementRef;
  @ViewChild('slidesList') slidesList: ElementRef;
  @Input() inputs: any = {};
  @Output() terminate = new EventEmitter<string>();
  @Output() requestNewQuestion = new EventEmitter<string>();
  @HostListener('window:resize', ['$event'])
  sizeChange(event) {
    let toFire = this.slidesList.nativeElement;
    let sBox = this.slidesBox.nativeElement;
    let ctW = sBox.offsetWidth;
    let cw = toFire.offsetWidth;
    let diff_delta = 5; // 5px
    if (cw - ctW > diff_delta) {
      this.showArr = true;
    } else {
      toFire.style.left = '0px';
      this.showArr = false;
    }

  }

  translations$: Observable<any> = this.translate.getTranslations$();
  isAudioExtPlaying$: Observable<any>;
  destroyed$: Subject<any> = new Subject<any>();

	ngAfterViewChecked(){
		// fired once
		if(this.current_id !== this.inputs.current.id){
			this.current_id = this.inputs.current.id;
			this.offsetControl();
		}
	}

  ngAfterViewInit() {
    window.dispatchEvent(new Event('resize'));
  }

  constructor(
    private translate: Translate,
    private viewSelectors: ViewSelectors
  ) {
    this.isAudioExtPlaying$ = this.viewSelectors.isAudioExtPlaying();
  }

	offsetControl(){
		let toFire = this.slidesList.nativeElement;
		let sBox = this.slidesBox.nativeElement;
		let ctW = sBox.offsetWidth;
		let cw = toFire.offsetWidth;
		let elem_width = 35;
    let position;
    let delta = 5;
		let space;
		this.inputs.questions.forEach((q, i) => {
			if(q.id === this.current_id){
				position = i + 1;
				space = position * elem_width;
			}
    });

		if(cw > (ctW + delta)){
			let move_to = Math.ceil((space - ctW) / elem_width) * elem_width;
			move_to = move_to < 0 ? 0 : move_to * -1;
			toFire.style.left = `${move_to}px`;
		}
	}

  goToQuestion(question) {
	  if (this.isAudioExtPlaying) {
      return;
    }
    if (this.inputs.current &&
      question.id === this.inputs.current.id ||
      typeof question === 'undefined') {
      return;
    }

    this.requestNewQuestion.emit(question);
  }

  goToNextQuestion() {
    if (!this.inputs.current ||
      !this.inputs.questions) {
      return;
    }

    let next = this.inputs.questions
      .reduce((check, question) => {
        if (typeof check === 'boolean' && check) {
          check = question;
        }

        return question.id === this.inputs.current.id ||
          check;
      }, null);

    if (typeof next !== 'boolean') {
      this.goToQuestion(next);
    }
  }

  goToPrevQuestion() {
    if (!this.inputs.current ||
      !this.inputs.questions) {
      return;
    }

    let index = -1;
    let prev = this.inputs.questions
      .reduce((check, question) => {

        if (question.id === this.inputs.current.id &&
          check !== null) {
          check = index;
        }

        index++;

        if (typeof check === 'object') {
          return question;
        } else {
          return check;
        }
      }, null);

    if (typeof prev !== 'object') {
      this.goToQuestion(this.inputs.questions[prev]);
    }
  }

  isCompletedByQuestionId(questionId, otherQuestionIds?) {
	  if (!this.inputs.progress) {
      return false;
    }
	  let i,
      checkList = [questionId].concat((typeof otherQuestionIds !== 'undefined' ? otherQuestionIds : []))
    ;
	  for (i = 0; i < checkList.length; i ++) {
      if (this.inputs.progress[checkList[i]] &&
        typeof this.inputs.progress[checkList[i]].answerId !== 'undefined' &&
        this.inputs.progress[checkList[i]].answerId !== -1) {
        return true;
      }
    }
	  return false;
  }

  colorStatusByQuestionId(questionId, otherQuestionIds?) {
    return this.isCompletedByQuestionId(questionId, otherQuestionIds)
      ? this.inputs.sectionColor
      : '';
  }

  prevBtns() {
      let toFire = this.slidesList.nativeElement;
      let sBox = this.slidesBox.nativeElement;
      let ctW = sBox.offsetWidth;
      let cw = toFire.offsetWidth;

      if (!toFire.style.left) {
          toFire.style.left = '-35px';
      } else {
          let cPos = Math.abs( parseInt(toFire.style.left, 10));
          let stopLeft = ctW + cPos;
          if ((cw - stopLeft) > 0) {
            let moveTo = (parseInt(toFire.style.left, 10) - 35) + 'px';
            toFire.style.left = moveTo;
          }
      }
  };

  nextBtns() {
    let toFire = this.slidesList.nativeElement;
    let ctr = !toFire.style.left || parseInt(toFire.style.left, 10) === 0;
    if (!ctr) {
      let moveTo = (parseInt(toFire.style.left, 10) + 35) + 'px';
      toFire.style.left = moveTo;
    }
  };

  ngOnInit () {
    this.isAudioExtPlaying$
      .takeUntil(this.destroyed$)
      .subscribe(isAudioExtPlaying => this.isAudioExtPlaying = isAudioExtPlaying);
  }

  ngOnDestroy () {
    this.destroyed$.next();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/cs-navigator/cs-navigator.component.ts